$shm_hitalama_map_statistics $mol_view
	map $shm_hitalama_map
	active true
	widgets /$shm_hitalama_map_widget
	sub /
		<= Widgets $mol_view
			sub / <= widgets_text \
		<= Map_units $mol_view
			sub / <= map_units_text \
		<= Widget_units $mol_view
			sub / <= widget_units_text \
		<= Lands $mol_view
			sub / <= lands_text \
		<= Loading_time $mol_view
			sub / <= loading_time_text \
